import script from "./compPostsStatsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./compPostsStatsPanel.vue?vue&type=script&setup=true&lang=js"

import "./compPostsStatsPanel.vue?vue&type=style&index=0&id=5ede65e5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ede65e5"]])

export default __exports__